<template>
  <section class="status__template">
    <Spiner />

    <section>
      <h3>{{ $t("descriptions.search_account_data") }}</h3>
      <small>{{ $t("descriptions.please_wait_moment") }}...</small>
    </section>
  </section>
</template>

<script>
import Spiner from "@/components/widgets/loaders/Spiner.vue";

export default {
  name: "IsLoadingComponent",

  components: {
    Spiner,
  },
};
</script>

<style lang="scss" scoped>
.status__template {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
  text-align: center;

  .description {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .remove__gap {
    margin-top: -25px;
  }
}
</style>
